import { getBatteryBadgeClasses, getBatteryTier } from '@gpx-spa/constants';

const BOLT_SVG = `
      <svg width="8" height="12" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.38826 1.33424C7.43814 1.10144 7.32513 0.864217 7.11291 0.756286C6.90069 0.648355 6.64241 0.696743 6.48366 0.874174L0.53366 7.52417C0.3956 7.67848 0.361124 7.89951 0.445636 8.08853C0.530148 8.27755 0.717861 8.39924 0.924912 8.39924H5.52549L4.61157 12.6642C4.56168 12.897 4.6747 13.1343 4.88691 13.2422C5.09913 13.3501 5.35741 13.3017 5.51616 13.1243L11.4662 6.47431C11.6042 6.32001 11.6387 6.09897 11.5542 5.90995C11.4697 5.72093 11.282 5.59924 11.0749 5.59924H6.47433L7.38826 1.33424Z" fill="currentColor" class="ICON_CLASS"/>
      </svg>`;

const BOLT_SLASH_SVG = `
      <svg width="10" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.28 2.22a.75.75 0 0 0-1.06 1.06l14.5 14.5a.75.75 0 1 0 1.06-1.06l-1.852-1.852 1.59-3.18a.75.75 0 0 0-.67-1.085h-3.998l1.69-3.38a.75.75 0 0 0-.83-1.064L9.78 8.72l-6.5-6.5Z M8.224 12.276 4.45 16.05a.75.75 0 0 0 1.06 1.06l4.013-4.013-1.298-.821Z" fill="currentColor" class="ICON_CLASS"/>
      </svg>`;

function badge(charge, classes, useBoltSlash) {
  const svg = (useBoltSlash ? BOLT_SLASH_SVG : BOLT_SVG).replace(
    'ICON_CLASS',
    classes.icon,
  );
  return `
    <div class="${classes.bg} ${classes.text} inline-flex items-center gap-x-[4px] pl-[8px] pr-[10px] rounded-[6px]">
      ${svg}
      <div class="inline-block text-[10px] leading-[17px] font-semibold">
        ${charge}<span class="font-normal bg-transparent">%</span>
      </div>
    </div>
  `;
}

export function getChargeEl(battery) {
  const tier = getBatteryTier(battery);
  if (tier === 'unknown') return '';
  const classes = getBatteryBadgeClasses(battery);
  return badge(battery, classes, tier === 'empty');
}
